import { useEffect, useRef } from "react";
import { Cta, AnimateFadeIn, AnimateSplitFadeIn } from "../";
import {
  StyledHero,
  StyledHeroLogo,
  StyledHeroCta,
  StyledHeroTitle,
} from "./styles.js";

export default function Hero({ small, text, scrollto }) {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current) {
      const observer = new window.IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            if (ref.current) {
              ref.current.classList.add("-inView");
            }
            return;
          }
          if (ref.current) {
            ref.current.classList.remove("-inView");
          }
        },
        {
          root: null,
          threshold: 0.1, // set offset 0.1 means trigger if atleast 10% of element in viewport
        }
      );
      observer.observe(ref.current);
    }
  });

  return (
    <StyledHero data-small={small}>
      <StyledHeroLogo style={{ display: small && "none" }} ref={ref}>
        <svg width="1807" height="1003" viewBox="0 0 1807 1003" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2096.09 -239.826C2285.63 -239.821 2438.5 -85.9639 2438.5 105.506C2438.07 186.409 2399.02 271.243 2363.22 325.543L1219.56 2055.27L1219.74 1155.17L1730.98 380.403C1748.5 353.863 1729.66 318.315 1698.09 318.315H1259.37C1237.54 318.315 1219.84 300.435 1219.84 278.379V-239.826H2096.09ZM1219.38 -239.514L708.132 535.258C690.619 561.798 709.45 597.346 741.024 597.346H1179.77C1201.59 597.353 1219.3 615.232 1219.3 637.282V1155.49H343.023C153.494 1155.48 0.619839 1001.65 0.614258 810.182C1.04263 729.274 40.1168 644.42 75.9215 590.118L1219.56 -1139.58L1219.38 -239.514Z" stroke="white" stroke-opacity="0.15" />
        </svg>

      </StyledHeroLogo>

      <StyledHeroTitle>
        <AnimateSplitFadeIn>{text}</AnimateSplitFadeIn>
      </StyledHeroTitle>

      {scrollto.label && (
        <StyledHeroCta
          onClick={() => {
            if (window.scroller) {
              window.scroller.scrollTo(window.innerHeight, true);
            } else {
              window.scrollTo({
                top: window.innerHeight,
                left: 0,
                behavior: "smooth",
              });
            }
          }}
        >
          <AnimateFadeIn delay={2}>
            <Cta>{scrollto.label}</Cta>
          </AnimateFadeIn>
        </StyledHeroCta>
      )}
    </StyledHero>
  );
}
